import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NetworkRoutingModule} from './network-routing.module';
import {MembersComponent} from './members/members.component';
import {MyMembersComponent} from './my-members/my-members.component';
import {SharedModule} from '../../shared/shared.module';
import {ReactiveFormsModule} from '@angular/forms';
import {CoreCommonModule} from '../../../@core/common.module';

@NgModule({
    declarations: [MembersComponent, MyMembersComponent],
    imports: [
        CommonModule,
        NetworkRoutingModule,
        SharedModule,
        ReactiveFormsModule,
        CoreCommonModule
    ]
})
export class NetworkModule {
}
